const init = () => {
  const navigationEl = document.querySelector("header nav");

  if (navigationEl) {
    const itemsEl = navigationEl.querySelectorAll("ul a");
    let name = false;
    let section = false;

    itemsEl.forEach(el => {
      el.addEventListener("click", e => {
        name = el.getAttribute("href").replace("/", "");
        section = document.querySelector("section#" + name);
        document.querySelector("input#toggle-nav").checked = false;
        if (section && el.getAttribute("data-target") != "single") {
          e.preventDefault();
          scrollTo(section, name);
        }
      });
    });

    name = location.pathname.replace(/\//gi, "");
    if (name != "") {
      section = document.querySelector("section#" + name);
      if (section) {
        scrollTo(section, name);
      }
    } else {
      const header = document.querySelector("header");
      header.classList.remove("fixed");
    }
  }
};

const scrollTo = (section, name) => {
  const dimensions = section.getBoundingClientRect();
  window.scrollBy(0, dimensions.top - 65);
  window.history.pushState(null, null, "/" + name);
};

const scroll = () => {
  const header = document.querySelector("header");
  if (header) {
    const dimensions = header.getBoundingClientRect();

    if (window.pageYOffset > dimensions.height) {
      header.classList.add("fixed");
    } else {
      header.classList.remove("fixed");
    }
  }
};

module.exports = { init, scroll };
